import { memoize } from "lodash";
import { observable } from "mobx";

import { apiCallGetOnAlarmsData } from "../../../api/developer-api/api-call-get-on-alarms-data";
import { apiCallTurnOffAlarmData } from "../../../api/developer-api/api-call-turn-off alarms data";
import { TAlarmsSetOff } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class DevelopmentAlarmsStore {
  developmentAlarmData = observable.box<TAlarmsSetOff>([]);

  getAlarmsOnFromDatabase = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_TURN_OFF_ALARMS", true);
    const { status, data, code } = await apiCallGetOnAlarmsData();
    getCoreUIStore().setIsLoading("DEVELOPER_TURN_OFF_ALARMS", false);
    if (status === "OK") {
      const editedData = data.map((item) => ({
        ...item,
        Alarm_Action: { AlarmId: item.id, reasonID: item.reason_id }
      }));
      this.developmentAlarmData.set(editedData);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  setAlarmOff = async (AlarmId: number, reasonID: number) => {
    getCoreUIStore().setIsLoading("DEVELOPER_TURN_OFF_ALARMS", true);
    const { status, code, data } = await apiCallTurnOffAlarmData(
      AlarmId,
      reasonID
    );
    getCoreUIStore().setIsLoading("DEVELOPER_TURN_OFF_ALARMS", false);
    if (status === "OK") {
      const editedData = data.map((item) => ({
        ...item,
        Alarm_Action: { AlarmId: item.id, reasonID: item.reason_id }
      }));
      this.developmentAlarmData.set(editedData);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}
const getDevelopmentAlarmsStore = memoize(
  () => new DevelopmentAlarmsStore(),
  () => 1
);
export default getDevelopmentAlarmsStore;
